export default __webpack_public_path__ + "static/dan-bio-home-474bde5e29647de2b658e3441e27dad1.jpg";